<template>
  <div id="sale">
    <p>请您填写售后原因:</p>
    <textarea v-model="textarea"></textarea>
    <div class="btn">
      <mt-button size="large" type="primary" @click="submit()">提交</mt-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textarea: "",
      orderId:'',
    };
  },
  mounted() {
      this.orderId = this.$route.params.id;
  },
  methods: {
    submit() {
      if (this.textarea == "") {
        this.$toast("请填写售后原因");
        return;
      }
      this.getAfterSale();
    },
    //申请售后
    getAfterSale() {
      this.post(this.apis.applyOderBuyService, {
        des: this.textarea,
        orderId: this.orderId,
      })
        .then((response) => {
          this.$toast({
            message: response.data.retMsg,
            duration: 1800,
          });
          if (response.data.retCode == "SUCCESS") {
            setTimeout(() => {
              this.changeRouter("/orderList/1");
            }, 1900);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
#sale {
  p {
    padding-left: 50px;
    padding-top: 50px;
  }
  textarea {
    margin: 30px auto;
    display: block;
    width: 600px;
    height: 500px;
    padding: 20px;
    color: rgb(51, 51, 51);
  }
  .btn {
    width: 90%;
    margin: 60px auto;
  }
}
</style>
